import { render } from "./appHostTopicInfo.vue?vue&type=template&id=6dc2de76&scoped=true"
import script from "./appHostTopicInfo.vue?vue&type=script&lang=js"
export * from "./appHostTopicInfo.vue?vue&type=script&lang=js"

import "./appHostTopicInfo.vue?vue&type=style&index=0&id=6dc2de76&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dc2de76"]])

export default __exports__